// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2-_cm","notes":"Notes_notes__3KDBT"};